import { Injector, Provider } from '@angular/core';
import { environment } from 'environments/environment';
import { ERROR_REPORTING_PORT } from './error-reporting.token';
import { ErrorReportingPort } from './error-reporting.port';
import { BugsnagErrorReportingAdapter } from './adapters/bugsnag-error-reporting.adapter';
import { NoopErrorReportingAdapter } from './adapters/noop-error-reporting.adapter';

export function errorReportingFactory(injector: Injector): ErrorReportingPort {
    const bugsnagApiKey: string = (environment.TOKEN_BUGSNAG_APIKEY ?? '').trim();

    if (bugsnagApiKey) {
        const adapter: BugsnagErrorReportingAdapter = injector.get(BugsnagErrorReportingAdapter);
        adapter.start();

        return adapter;
    }

    const adapter: NoopErrorReportingAdapter = injector.get(NoopErrorReportingAdapter);
    adapter.start();

    return adapter;
}

export const ERROR_REPORTING_PROVIDER: Provider = {
    provide: ERROR_REPORTING_PORT,
    useFactory: errorReportingFactory,
    deps: [Injector],
};
